function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M358.387,159.975h-38.9c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h38.9c19.1,0,34.7,15.6,34.7,34.7v193.8 c0,19.1-15.6,34.7-34.7,34.7h-239.8c-19.1,0-34.7-15.6-34.7-34.7v-193.9c0-19.1,15.6-34.7,34.7-34.7h38.9c7.5,0,13.5-6,13.5-13.5 s-6-13.5-13.5-13.5h-38.9c-34,0-61.7,27.7-61.7,61.7v193.8c0,34,27.7,61.7,61.7,61.7h239.9c34,0,61.7-27.7,61.7-61.7v-193.8 C420.087,187.575,392.387,159.975,358.387,159.975z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.987,104.175l58-58v218c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5v-218l58,58c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4 c5.3-5.3,5.3-13.8,0-19.1l-81.1-81.1c-5.3-5.3-13.8-5.3-19.1,0l-81.1,81.1c-5.3,5.3-5.3,13.8,0,19.1 C153.187,109.475,161.687,109.475,166.987,104.175z"
})));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 477.075 477.075",
    style: {
      "enableBackground": "new 0 0 477.075 477.075"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ios-share-icon.d88f6a1f.svg";
export { SvgComponent as ReactComponent };